import React, { forwardRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faShoppingBasket,
  faShoppingCart,
  faHome
} from '@fortawesome/free-solid-svg-icons';
import { useCart } from '../../context/CartContext';
import './index.css';

interface NavbarProps {
  className?: string;
}

const Navbar = forwardRef<HTMLElement, NavbarProps>((props, ref) => {
  const { cart } = useCart();
  
  // 1. Calculate the total
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  // 2. Derived State: Calculate this on the fly!
  const cartHasItems = cart.length > 0;

  // 3. Helper inside the component (or just use a ternary in the JSX)
  const cartText = total > 0 ? `$${total.toFixed(2)}` : '';

  return (
    <nav ref={ref} className={props.className}>
      <div className="nav-top-row">
        <ul className="nav-pill nav-left">
          <li>
            <NavLink to="/" className={({ isActive }) => isActive ? 'active logo-link' : 'logo-link'}>
              <FontAwesomeIcon icon={faHome} className="hc_nav_icon" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/shop" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faShoppingBasket} className="hc_nav_icon" />
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faInfoCircle} className="hc_nav_icon" />
            </NavLink>
          </li>
        </ul>
        <ul className="nav-pill nav-right">
          <li>
            <NavLink 
              to="/cart" 
              className={({ isActive }) => {
                const baseClasses = "cart-link cart-link-expand";
                const activeClass = isActive ? "active" : "";
                const hasItemsClass = cart.length > 0 ? "cart-has-items" : "";
                
                return `${baseClasses} ${activeClass} ${hasItemsClass}`.trim();
              }}
            >
              <FontAwesomeIcon
                icon={faShoppingCart}
                className={`hc_nav_icon ${cart.length > 0 ? 'cart-glow' : ''}`}
              />
              {/* Only show the span if there is a total to display */}
              {total > 0 && (
                <span style={{ marginLeft: '6px' }}>
                  ${total.toFixed(2)}
                </span>
              )}
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
});


Navbar.displayName = 'Navbar';

export default Navbar;